// Register page translations
export default {
  title: "User Registration",
  subtitle: "Create your new account",
  switchToLogin: "Already have an account? Login",

  // Form field labels and placeholders
  account: "Account",
  accountPlaceholder: "Please enter account",
  phone: "Phone",
  phonePlaceholder: "Please enter phone number",
  captcha: "Verification Code",
  captchaPlaceholder: "Please enter SMS verification code",
  password: "Password",
  passwordPlaceholder:
    "8-16 characters, including letters, numbers and special characters",
  confirmPassword: "Confirm Password",
  confirmPasswordPlaceholder: "Please confirm password again",

  // Button text
  register: "Register",
  getCaptcha: "Get Verification Code",
  closeDialog: "Close",
  backToLogin: "Back to Login",

  // Success messages
  registerSuccess: "Registration Successful!",
  registerSuccessSubtitle: "Add WeChat for more services!",

  // Error messages
  registerFailed: "Registration failed, please try again",
  getCaptchaFirst: "Please get verification code first or code has expired!",

  // Form validation messages
  validation: {
    accountRequired: "Please enter account",
    accountLength: "Length should be 2 to 20 characters",
    phoneRequired: "Please enter phone number",
    phoneFormat: "Please enter a valid phone number",
    captchaRequired: "Please enter verification code",
    captchaFormat: "Invalid verification code format",
    passwordRequired:
      "8-16 non-Chinese characters, including at least 1 letter, 1 number and 1 special character",
    passwordLength:
      "8-16 non-Chinese characters, including at least 1 letter, 1 number and 1 special character",
    passwordPattern:
      "Password must contain at least 1 letter, 1 number and 1 special character within 8-16 non-Chinese characters",
    passwordAscii: "Please enter 8-16 non-Chinese characters",
    passwordLetter: "Please include at least one letter",
    passwordNumber: "Please include at least one number",
    passwordSpecial:
      "Please include at least one non-Chinese special character",
    confirmPasswordRequired: "Please enter password again",
    passwordMismatch: "Passwords do not match, please re-enter",
  },
};
